// Module
var code = "<toggle v-if=\"form\" :disabled=\"disabled\" :label=\"label ? label : name\" :value.sync=\"form[field]\" :validation=\"form.validation[field]\"><slot>{{ label || name }}</slot></toggle> ";
// Exports
export default code;